import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SsoSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      // In a real app, you might want to call a login function that sets the user state too
      // For now, let's assume setToken handles what we need
      localStorage.setItem('token', token);
      // We might need to refresh the page or call a function to update the AuthContext
      window.location.href = '/';
    } else {
      navigate('/login?error=SSO%20Token%20Missing');
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Completing SSO Login...</h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">Please wait while we sign you in.</p>
        <div className="mt-4 flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand"></div>
        </div>
      </div>
    </div>
  );
};

export default SsoSuccess;
